const paymentState = {
    params: {
        planId: ''
    }
};

const payment = {
    namespaced: true,
    state: paymentState,
    mutations: {
        setParams(state, payload) {
            Object.assign(state.params, payload);
        },
        reset(state) {
            Object.assign(state.params, paymentState.params);
        }
    },
    actions: {
        setParams({ commit }, response) {
            commit('setParams', response);
        },
        reset({ commit }) {
            commit('reset');
        }
    }
};

export default payment;
